(() => {
  'use strict';
  const root = document.querySelector('[data-wi-clarity]');
  if (!root || root.dataset.wiClarityReady === 'true') return;
  root.dataset.wiClarityReady = 'true';

  const status = root.querySelector('[data-wi-clarity-status]');
  const allowButton = root.querySelector('[data-wi-clarity-allow]');
  const denyButton = root.querySelector('[data-wi-clarity-deny]');
  const retryButton = root.querySelector('[data-wi-clarity-retry]');
  if (!status || !allowButton || !denyButton || !retryButton) return;

  const projectId = 'yuwz7rho2r';
  const blockKey = 'wi_optional_analytics_blocked_v1';
  const denied = { ad_Storage: 'denied', analytics_Storage: 'denied' };
  let api = null;
  let apiLoading = false;
  let saving = false;
  let requested = false;
  let owned = false;
  let locked = false;
  let tag = null;
  let decisionTimer = null;
  let apiTimer = null;
  let apiAttempt = 0;
  let decisionId = 0;
  let pendingChoice = null;
  let generation = 0;
  let navigationGuardReady = false;

  const say = (text) => { status.textContent = text; };
  const disable = (value) => {
    allowButton.disabled = value;
    denyButton.disabled = value;
  };
  const privacy = () => {
    const value = window.Shopify && window.Shopify.customerPrivacy;
    return value && typeof value.analyticsProcessingAllowed === 'function' &&
      typeof value.currentVisitorConsent === 'function' &&
      typeof value.setTrackingConsent === 'function' ? value : null;
  };
  const explicitYes = () => {
    try {
      return api && api.analyticsProcessingAllowed() === true &&
        api.currentVisitorConsent().analytics === 'yes';
    } catch (_) { return false; }
  };
  const blockState = () => {
    try { return window.localStorage.getItem(blockKey); }
    catch (_) { return 'unavailable'; }
  };
  const writeBlock = (blocked) => {
    try {
      if (blocked) window.localStorage.setItem(blockKey, '1');
      else window.localStorage.removeItem(blockKey);
      return blockState() === (blocked ? '1' : null);
    } catch (_) { return false; }
  };
  const pageEligible = () => {
    const here = window.location;
    return (here.hostname === 'worthxlab.com' || here.hostname === 'www.worthxlab.com') &&
      root.dataset.wiProductPage === 'true' &&
      here.pathname.replace(/\/$/, '') === (root.dataset.wiProductPath || '').replace(/\/$/, '') &&
      /^\/products\/[^/]+\/?$/.test(here.pathname) &&
      !here.search && !here.hash && !(window.Shopify && window.Shopify.designMode);
  };
  const clearClarityStorage = () => {
    // Only Clarity's own published cookie names; never read or edit Shopify cookies.
    const host = window.location.hostname.split('.');
    const domains = [''];
    for (let i = 0; i < host.length - 1; i += 1) domains.push(host.slice(i).join('.'));
    for (const name of ['_clck', '_clsk']) {
      for (const domain of domains) {
        try {
          document.cookie = `${name}=; Max-Age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${domain ? `; domain=${domain}` : ''}`;
        } catch (_) { /* A blocked cookie store must not prevent saving the visitor's choice. */ }
      }
    }
    try { window.sessionStorage.removeItem('_cltk'); } catch (_) { /* Storage can be blocked. */ }
  };
  const stopOwned = () => {
    locked = true;
    generation += 1;
    if (owned && typeof window.clarity === 'function') {
      // Discard our queued grant if either hosted script is still loading.
      if (Array.isArray(window.clarity.q)) {
        window.clarity.q = window.clarity.q.filter((entry) => entry[0] !== 'consentv2');
      }
      try {
        // Active denied->stop schedules a restart in the current hosted engine.
        // Stop first: the stopped dispatcher queues the denial without executing it.
        window.clarity('stop');
        window.clarity('consentv2', denied);
      } catch (_) { /* Reload still closes this document; collection is not certified here. */ }
    }
    if (tag) tag.remove();
    clearClarityStorage();
  };
  const reload = () => {
    try { window.location.reload(); }
    catch (_) {
      say('Please refresh this page to finish applying your privacy choice.');
      disable(false);
      retryButton.hidden = false;
    }
  };
  const loadTracker = () => {
    if (requested || locked || !explicitYes() || blockState() !== null || !pageEligible()) return;
    if (!navigationGuardReady) {
      say('Analytics stays off while page privacy protection is checked.');
      return;
    }
    if (!document.body || document.body.getAttribute('data-clarity-mask') !== 'true') {
      say('Analytics stays off while privacy protection is checked.');
      return;
    }
    if (typeof window.clarity !== 'undefined' || document.querySelector('script[src*="clarity.ms/"]')) {
      say('Your saved choice is allowed. Analytics setup needs checking.');
      return;
    }
    requested = true;
    owned = true;
    const currentGeneration = generation;
    window.clarity = function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
    window.clarity('consentv2', { ad_Storage: 'denied', analytics_Storage: 'granted' });
    tag = document.createElement('script');
    tag.async = true;
    tag.src = `https://www.clarity.ms/tag/${projectId}`;
    tag.dataset.wiOptionalAnalytics = 'true';
    tag.addEventListener('load', () => {
      if (locked || currentGeneration !== generation || !explicitYes() || blockState() !== null) stopOwned();
      // Loading the bootstrap is not proof of recording delivery or masking.
    }, { once: true });
    tag.addEventListener('error', () => {
      stopOwned();
      say('Your choice is saved. Optional analytics could not load on this visit.');
    }, { once: true });
    // Recheck immediately before the only vendor request this integration starts.
    if (!explicitYes() || blockState() !== null || locked) { stopOwned(); return; }
    document.head.appendChild(tag);
  };
  const refreshChoice = (externalDenial = false) => {
    if (!api) {
      if (owned) {
        writeBlock(true);
        stopOwned();
      }
      disable(true);
      retryButton.hidden = false;
      say('Privacy settings could not be checked. Optional analytics stays off; try again.');
      return;
    }
    const allowed = explicitYes();
    const blocked = blockState() !== null;
    const grantSaving = saving && pendingChoice === true;
    if ((!allowed || blocked) &&
      ((owned && (!grantSaving || !allowed || externalDenial)) ||
        (grantSaving && (!allowed || externalDenial)))) {
      // Withdrawal takes priority over an older grant request or its late callback.
      decisionId += 1;
      if (decisionTimer !== null) window.clearTimeout(decisionTimer);
      decisionTimer = null;
      saving = false;
      pendingChoice = null;
      disable(false);
      const stored = writeBlock(true);
      stopOwned();
      say('Optional analytics is off. Refreshing to finish applying your choice…');
      if (stored) reload();
      else say('Optional analytics was stopped on this page. Refresh after saving your privacy choice.');
      return;
    }
    if (saving) return;
    if (allowed && blockState() === null && !locked) {
      say(pageEligible() ? 'Your saved choice: optional analytics allowed.' : 'Your saved choice: analytics allowed. It stays off on this page.');
      loadTracker();
    } else {
      say(blockState() === 'unavailable' ? 'Optional analytics stays off because privacy storage is unavailable.' : 'Optional analytics is off. You can shop normally.');
    }
  };
  const finishApi = () => {
    if (apiTimer !== null) window.clearTimeout(apiTimer);
    apiTimer = null;
    apiLoading = false;
    api = privacy();
    if (!api) {
      say('Optional analytics stays off. Privacy settings could not load; try again.');
      retryButton.hidden = false;
      disable(true);
      return;
    }
    retryButton.hidden = true;
    disable(false);
    refreshChoice();
  };
  const ensureApi = () => {
    if (apiLoading) return;
    if (privacy()) { finishApi(); return; }
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      say('Optional analytics stays off. Privacy settings are unavailable; try again.');
      retryButton.hidden = false;
      return;
    }
    apiLoading = true;
    const attempt = ++apiAttempt;
    apiTimer = window.setTimeout(() => {
      if (attempt !== apiAttempt) return;
      apiAttempt += 1;
      finishApi();
    }, 2000);
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (attempt !== apiAttempt) return;
        if (error) apiLoading = false;
        finishApi();
      });
    } catch (_) { apiLoading = false; finishApi(); }
  };
  const decide = (allowed) => {
    if (!api || saving) return;
    saving = true;
    const currentDecision = ++decisionId;
    pendingChoice = allowed;
    disable(true);
    retryButton.hidden = true;
    // Every preference change stops this document first, even a repeated Allow.
    // A single necessary privacy boolean survives a failed Shopify save.
    const safelyBlocked = writeBlock(true);
    stopOwned();
    say(allowed ? 'Saving your choice. The page will refresh…' : 'Turning off optional analytics. The page will refresh…');
    decisionTimer = window.setTimeout(() => {
      if (currentDecision !== decisionId) return;
      decisionId += 1;
      decisionTimer = null;
      saving = false;
      pendingChoice = null;
      disable(false);
      if (!allowed && safelyBlocked) { reload(); return; }
      say('The saved choice could not be confirmed. Optional analytics stays off here; try again.');
      locked = true;
      retryButton.hidden = false;
    }, 2000);
    try {
      api.setTrackingConsent({ analytics: allowed }, (error) => {
        if (currentDecision !== decisionId) return;
        decisionId += 1;
        if (decisionTimer !== null) window.clearTimeout(decisionTimer);
        decisionTimer = null;
        saving = false;
        pendingChoice = null;
        disable(false);
        let saved = false;
        try { saved = !error && (allowed ? explicitYes() : api.currentVisitorConsent().analytics === 'no'); }
        catch (_) { /* Unknown consent is a failed confirmation. */ }
        if (!saved) {
          if (!allowed && safelyBlocked) { reload(); return; }
          locked = true;
          say('The saved choice could not be confirmed. Optional analytics stays off here; try again.');
          retryButton.hidden = false;
          return;
        }
        if (allowed && !writeBlock(false)) {
          locked = true;
          say('Your choice is saved, but analytics stays off because privacy storage is unavailable.');
          return;
        }
        reload();
      });
    } catch (_) {
      if (decisionTimer !== null) window.clearTimeout(decisionTimer);
      decisionTimer = null;
      saving = false;
      pendingChoice = null;
      disable(false);
      locked = true;
      if (!allowed && safelyBlocked) { reload(); return; }
      say('Your choice could not be saved. Optional analytics stays off here; try again.');
      retryButton.hidden = false;
    }
  };

  const navigationChanged = () => {
    if (!owned) return;
    if (!pageEligible()) {
      stopOwned();
      say('Optional analytics stays off on this page. Your saved choice is unchanged.');
      return;
    }
    refreshChoice();
  };
  const prepareNavigationGuard = () => {
    try {
      const history = window.history;
      if (!history || typeof history.pushState !== 'function' || typeof history.replaceState !== 'function') return;
      for (const method of ['pushState', 'replaceState']) {
        const original = history[method];
        const guarded = function (...args) {
          const result = original.apply(this, args);
          // Installed before the vendor: stop inside its outer history wrapper,
          // before its active check can schedule a restart for a sensitive URL.
          navigationChanged();
          return result;
        };
        history[method] = guarded;
        if (history[method] !== guarded) return;
      }
      navigationGuardReady = true;
    } catch (_) { /* Unsupported navigation protection means no tracker load. */ }
  };

  prepareNavigationGuard();
  allowButton.addEventListener('click', () => decide(true));
  denyButton.addEventListener('click', () => decide(false));
  retryButton.addEventListener('click', ensureApi);
  document.addEventListener('visitorConsentCollected', () => { api = privacy(); refreshChoice(); });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') { api = privacy(); refreshChoice(); }
  });
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) { api = privacy(); refreshChoice(); }
  });
  window.addEventListener('popstate', navigationChanged);
  window.addEventListener('hashchange', navigationChanged);
  window.addEventListener('storage', (event) => {
    try {
      if (event.storageArea === window.localStorage && (event.key === blockKey || event.key === null)) {
        api = privacy();
        refreshChoice(blockState() !== null);
      }
    } catch (_) {
      if (owned) stopOwned();
    }
  });
  ensureApi();
})();
